const columns =[
    {
        title: 'Name',
        dataIndex: 'name',
    },
    {
        title:'A/C No.',
        dataIndex: 'accountId',
    },
    {
        title: 'Deposit Amount',
        dataIndex: 'depositAmount',
    },
    {
        title: 'Net Profit',
        dataIndex: 'netProfit',
    },
    {
        title: 'Net Profit %',
        dataIndex: 'netProfitPercent',
    },
    {
        title: 'Close Profit',
        dataIndex: 'closeProfit',
    },
    {
        title: 'Action',
        dataIndex: 'action',
    },
];

export default columns;